import { render, staticRenderFns } from "./calculo-tabela-referencia.vue?vue&type=template&id=6408911f&scoped=true"
import script from "./calculo-tabela-referencia.vue?vue&type=script&lang=ts"
export * from "./calculo-tabela-referencia.vue?vue&type=script&lang=ts"
import style0 from "./calculo-tabela-referencia.vue?vue&type=style&index=0&id=6408911f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6408911f",
  null
  
)

export default component.exports